<template>
  <div class="
      fixed
      confirm-order
      h-full
      w-full
      left-0
      top-0
      bottom-0
      right-0
      bg-white
      p-4
      overflow-x-hidden
    ">
    <div class="confirm-order-content">
      <div class="confirm-order-content-column">
          <div class="order-mockup">
          <div class="font-bold mb-2"> {{$t('client.confirm_order.3d_order')}}: </div>
          <div class="order-image">
            <img
              v-if="order.mockup"
              class="object-cover"
              :src="order.mockup"
              loading="lazy"
              alt=""
            >
            <img
              v-else
              src="/images/spinner.svg"
              loading="lazy"
              alt=""
            >

          </div>
        </div>
        <div
          class="order-faces mt-4"
          v-if="order.order_faces"
        >
          <div class="font-bold mb-2"> Оформление: </div>
          <div class="order-faces-list">
            <div
              class="order-faces-item"
              v-for="(face, index) in order.order_faces"
              :key="`faces-mock-${index}`"
            >
              <div class="order-faces-name text-sm">
                <span>{{index+1}}</span>
                <span
                  class="order-face-name"
                  v-html="face.name"
                ></span>

              </div>
              <div
                class="order-faces-image"
                @click.prevent="popupFace = face"
              >

                <img
                  :src="face.image"
                  loading="lazy"
                  alt=""
                >
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="confirm-order-content-column">
        <div class="font-bold mb-4">{{$t('client.confirm_order.order_detail')}}:</div>
        <div class="elements">
          <div
            v-if="order.plot"
            class="text-xl mb-4"
          >
            {{ order.plot.name }}
          </div>

          <div
            class="element-item-list"
            v-if="order.order_elements&&order.order_elements.length"
          >
            <card-element-cart
              v-for="element in order.order_elements"
              :key="`complectation-element-${element.element_id}`"
              :element="element"
              :settings="settings"
            />
          </div>

          <card-landscaping-order
            class="mb-4 border-blue-top"
            v-if="order.order_landscaping && order.order_landscaping.length"
            :settings="settings"
            :landscapings="order.order_landscaping"
          ></card-landscaping-order>

          <div
            v-if="order.barrier"
            class="text-xl mb-4 border-blue-top element-item-list"
          >
            <card-barrier-cart
              :barrier="order.barrier"
              :settings="settings"
            />
          </div>

          <CardEngravingCart
            v-if="order.order_faces && order.order_faces.length"
            class="mb-4 border-blue-top"
            :faces="order.order_faces"
            :settings="settings"
            :isComplectation="false"
          />
        </div>
      </div>
      <div class="confirm-order-content-column">
        <div class="font-bold mb-4">{{$t('client.confirm_order.title')}}</div>
        <div class="text-2xl font-bold mb-2">{{$t('client.success_order.thanks')}}!</div>
        <div class="font-bold mb-2">{{$t('client.success_order.success_formed')}}!</div>
        <div class="mb-4">
          {{$t('client.success_order.manager_will_connect')}}
        </div>
        <div
          class="mb-4"
          v-if="settings.show_button_pdf_order"
        >
          <a
            :href="`/generate-pdf/${order.order_id}`"
            class="flex items-center"
          >
            <span
              class="icon-download-pdf"
              style="background-image: url('/images/icons/icon-pdf.svg')"
            ></span>
            <span class="ml-2 text-sm">{{$t('client.success_order.download_pdf')}}</span>
          </a>
        </div>
        <div
          class="mb-4"
          v-if="settings.mail_send_to_client_enabled && settings.send_copy_order_for_client && order.email"
        >
          {{$t('client.success_order.dublicate_to_mail')}}
        </div>
        <div>
          <button
            class="bg-red-500 text-lg text-white px-4 py-2 rounded border"
            @click="onSuccessOrderCloseHandle"
          >
            {{$t('main.close')}}
          </button>
        </div>
      </div>
    </div>
    <ClientModal
      v-if="popupFace"
      @close-modal="popupFace = null"
      class="popupFace"
      propWidth="auto"
      propHeight="auto"
    >
      <template
        #header
        v-html="popupFace.faceName || popupFace.name"
      ></template>

      <div
        class="order-face-popup-image"
        :style="{ backgroundImage: `url(${popupFace.image})` }"
      ></div>
    </ClientModal>

  </div>
</template>
<script>
import CardBarrierCart from "../../components/General/CardBarrierCart.vue";
import CardElementCart from "../../components/General/CardElementCart.vue";
import CardLandscapingCart from "../../components/General/CardLandscapingCart.vue";
import CardEngravingCart from "../../components/General/CardEngravingCart.vue";
import CardLandscapingOrder from "../../components/General/CardLandscapingOrder.vue";
export default {
  components: {
    CardElementCart,
    CardLandscapingCart,
    CardBarrierCart,
    CardEngravingCart,
    CardLandscapingOrder,
  },
  data() {
    return {
      popupFace: null,
    };
  },
  computed: {
    order() {
      return this.$route.params.order;
    },
    settings() {
      return this.$store.state.settings.settings;
    },
  },
  methods: {
    onSuccessOrderCloseHandle() {
      location.href = "/";
    },
  },
};
</script>
<style scoped>
.confirm-order {
  z-index: 9999;
}
.confirm-order-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 100%;
}
.column__title {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.1;
}
.confirm-order-content-column {
  padding-top: 20px;
  padding-bottom: 40px;
}
.confirm-order-content-column + .confirm-order-content-column {
  border-left: 1px solid #ccdfe8;
  margin-left: 15px;
  padding-left: 15px;
}
.order-faces-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}
.order-faces-item {
}
.order-faces-name {
  margin-bottom: 0.5rem;
}
.order-faces-image {
  border: 1px solid #c0c4d1;
  background-color: #fff;
  padding: 0.25rem;
  min-height: 200px;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-faces-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.order-face-popup-image {
  border: 1px solid #c0c4d1;
  background-color: #fff;
  padding: 0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  --popup-size: min(900px, 90vw, 85vh);
  height: var(--popup-size);
  width: var(--popup-size);
  margin: auto;
}
.label-politic span {
  text-decoration: underline;
}
</style>
